import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAboutServ,
  updateAboutCardsServ,
} from "../../services/about.service";

const emptyCard = { image: "", title: "", subtitle: "" };

function AboutCards() {
  // 3 cards fixed
  const [cards, setCards] = useState([
    { ...emptyCard },
    { ...emptyCard },
    { ...emptyCard },
  ]);
  // naye upload kiye gaye files (index wise)
  const [files, setFiles] = useState([null, null, null]);
  const [btnLoader, setBtnLoader] = useState(false);

  const getAboutFunc = async () => {
    try {
      const response = await getAboutServ();
      const data = response?.data?.data;
      if (data?.cards?.length) {
        // hamesha 3 cards ensure karo
        const filled = [0, 1, 2].map((i) => data.cards[i] || { ...emptyCard });
        setCards(filled);
      }
    } catch (error) {
      toast.error("Failed to fetch About Us cards");
    }
  };

  useEffect(() => {
    getAboutFunc();
  }, []);

  const handleFieldChange = (index, field, value) => {
    setCards((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleFileChange = (index, file) => {
    setFiles((prev) => {
      const updated = [...prev];
      updated[index] = file;
      return updated;
    });
    // preview ke liye local url
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      handleFieldChange(index, "image", previewUrl);
    }
  };

  const handleUpdate = async () => {
    setBtnLoader(true);
    try {
      const formData = new FormData();
      // image (existing url) + title + subtitle bhejte hain; nayi file alag
      const cardsPayload = cards.map((c) => ({
        image: c.image?.startsWith("blob:") ? "" : c.image || "",
        title: c.title || "",
        subtitle: c.subtitle || "",
      }));
      formData.append("cards", JSON.stringify(cardsPayload));
      files.forEach((file, i) => {
        if (file) formData.append(`cardImage${i}`, file);
      });

      const response = await updateAboutCardsServ(formData);
      if (response?.data?.statusCode === 200) {
        toast.success(response.data.message);
        setFiles([null, null, null]);
        getAboutFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="About Us Manager" selectedItem="About Cards" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{ position: "relative", top: "-75px", marginBottom: "-75px" }}
          ></div>

          <div className="mt-3">
            <div className="card-body px-2">
              <div className="d-flex">
                <h4
                  className="p-2 text-dark shadow rounded mb-4"
                  style={{ background: "#05E2B5" }}
                >
                  About Us : Cards (3)
                </h4>
              </div>

              <div className="row">
                {cards.map((card, index) => (
                  <div className="col-md-4 col-12 mb-3" key={index}>
                    <div className="border rounded p-3 h-100">
                      <h6 className="fw-bold mb-3">Card {index + 1}</h6>

                      <div className="d-flex justify-content-center mb-2">
                        <img
                          src={
                            card.image
                              ? card.image
                              : "https://cdn-icons-png.flaticon.com/128/159/159626.png"
                          }
                          alt="card"
                          style={{
                            height: "90px",
                            width: "90px",
                            objectFit: "contain",
                          }}
                        />
                      </div>

                      <label className="small mb-1">Icon / Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        className="form-control mb-2"
                        onChange={(e) =>
                          handleFileChange(index, e.target.files[0])
                        }
                      />

                      <label className="small mb-1">Title</label>
                      <input
                        type="text"
                        className="form-control mb-2"
                        value={card.title}
                        onChange={(e) =>
                          handleFieldChange(index, "title", e.target.value)
                        }
                        placeholder="e.g. Who we are"
                      />

                      <label className="small mb-1">
                        Subtitle{" "}
                        <span className="text-muted">
                          (nayi line = naya paragraph)
                        </span>
                      </label>
                      <textarea
                        rows={5}
                        className="form-control"
                        value={card.subtitle}
                        onChange={(e) =>
                          handleFieldChange(index, "subtitle", e.target.value)
                        }
                        placeholder="Card ka description likhein..."
                      />
                    </div>
                  </div>
                ))}
              </div>

              <button
                className="btn btn-primary w-100 mt-2"
                style={{
                  background: "#61ce70",
                  border: "none",
                  borderRadius: "24px",
                }}
                onClick={handleUpdate}
                disabled={btnLoader}
              >
                {btnLoader ? "Updating ..." : "Update Cards"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutCards;
